import { render, staticRenderFns } from "./InvoicingList.vue?vue&type=template&id=56a0f51b"
import script from "./InvoicingList.vue?vue&type=script&lang=js"
export * from "./InvoicingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports